import { imageViewerModalService } from './imageViewerModalService';

export let imageViewerModal = {
	init: ($elements) => {
		let modalService = imageViewerModalService;

		if(_.isNil($elements)) {
			$elements = $('[image-modal-viewer="true"]');
		}

		$elements.each((index, element) => {
			$(element).append(`<button class='image-modal-viewer-btn btn' type="button"></button>`);
			$(element).find('.image-modal-viewer-btn').on('click', () => {
				modalService.show({
					body: $(element).children('img')[0].outerHTML
				});
			});
		});
	}
};
